import { IFormSchemaField } from "../types";

export const selectorVisibleFields = (
  fields: IFormSchemaField[]
): IFormSchemaField[] => fields.filter(f => f.operations.visible !== false);
